import React from "react";
import { connect } from "react-redux";
import { Typography, Box, withStyles, Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { AppointmentActions } from "../../redux/actions/AppointmentActions";
import { DoctorAction } from "../../redux/actions/DoctorAction";
import { PatientActions } from "../../redux/actions/PatientActions";
import AppointmentHistoryList from "./AppointmentHistoryList";
import { history } from "../../components/helpers/History";
import { USER_ROLE } from "../../components/security/UserRole";
import AppointmentHistoryFilter from "./AppointmentHistoryFilter";

const useStyles = (theme) => ({
  main: {
    marginTop: theme.spacing(4),
  },
  typography: {
    marginTop: theme.spacing(4),
  },
});

class AppointmentHistory extends React.Component {
  constructor(props) {
    super(props);
    const userRole = this.props.user.userRole ? this.props.userRole : "";
    this.state = {
      patientId: this.props.patientId
        ? [this.props.patientId]
        : userRole === USER_ROLE.PATIENT
        ? [this.props.user.patientId]
        : [],
      doctorId: this.props.doctorId
        ? [this.props.doctorId]
        : userRole === USER_ROLE.DOCTOR
        ? [this.props.user.doctorId]
        : [],
      status: this.props.status ? this.props.status : [],
      consultationType: this.props.consultationType
        ? [this.props.consultationType]
        : [],
      id: this.props.id ? this.props.id : "",
      startDateTime: this.props.startDateTime ? this.props.startDateTime : "",
      endDateTime: this.props.endDateTime ? this.props.endDateTime : "",
      showSingleGrid: this.props.showSingleGrid
        ? this.props.showSingleGrid
        : false,
      isCardView: this.props.isCardView ? this.props.isCardView : false,
      isCalenderView: this.props.isCalenderView
        ? this.props.isCalenderView
        : false,
      showAddNewAppointment: this.props.showAddNewAppointment
        ? this.props.showAddNewAppointment
        : false,
      showEditAppointment: this.props.showEditAppointment
        ? this.props.showEditAppointment
        : false,
      isViewTodayAppointment: this.props.isViewTodayAppointment
        ? this.props.isViewTodayAppointment
        : false,
      isViewPastAppointment: this.props.isViewPastAppointment
        ? this.props.isViewPastAppointment
        : false,
      isViewFutureAppointment: this.props.isViewFutureAppointment
        ? this.props.isViewFutureAppointment
        : false,
      isViewAllAppointment: this.props.isViewAllAppointment
        ? this.props.isViewAllAppointment
        : false,
      isViewWeeklyAppointment: this.props.isViewWeeklyAppointment
        ? this.props.isViewWeeklyAppointment
        : false,
      headerTitle: this.props.headerTitle
        ? this.props.headerTitle
        : "APPOINTMENT HISTORY",
      isCancelRequested: false,
      filterPayload: {},
    };
  }

  componentDidMount() {
    var payload = {
      id: this.state.id,
      startDateTime: this.state.startDateTime,
      endDateTime: this.state.endDateTime,
      status: this.state.status,
      doctorId: this.state.doctorId,
      patientId: this.state.patientId,
      consultationType: this.state.consultationType,
    };
    this.updateHistoryList(payload);
    const userRole = this.props.user.userRole ? this.props.user.userRole : "";
    if (userRole === USER_ROLE.PATIENT) {
      this.props.getAllDoctor();
    } else if (userRole === USER_ROLE.DOCTOR) {
      this.props.getAllPatient();
    } else {
      this.props.getAllDoctor();
      this.props.getAllPatient();
    }

    // if(userRole === USER_ROLE.PATIENT && this.props.allDoctorList && this.props.allDoctorList.length <= 0){
    //   this.props.getAllDoctor();
    // }else if(userRole === USER_ROLE.DOCTOR  && this.props.allPatientList && this.props.allPatientList.length <= 0){
    //   this.props.getAllPatient();
    // }else{
    //    if(this.state.patientId && this.state.patientId.length <=0  && this.props.allPatientList && this.props.allPatientList.length <= 0){
    //     this.props.getAllPatient();
    //   }if(this.state.doctorId && this.state.doctorId.length <=0  && this.props.allDoctorList && this.props.allDoctorList.length <= 0){
    //     this.props.getAllDoctor();
    //   }
    // }
  }
  updateHistoryList(payload) {
    if (this.state.isViewTodayAppointment) {
      this.props.getAllTodayAppointment(payload);
    } else if (this.state.isViewPastAppointment) {
      this.props.getAllPastAppointment(payload);
    } else if (this.state.isViewFutureAppointment) {
      this.props.getAllFuturAppointment(payload);
    } else if (this.state.isViewAllAppointment) {
      this.props.getAllAppointment(payload);
    } else if (this.props.isViewWeeklyAppointment) {
      this.props.getAllWeeklyAppointment(payload);
    } else if (this.props.isViewTomorrowAppointment) {
      this.props.getAllTomorrowAppointment(payload);
    } else {
      this.props.getAllAppointment(payload);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.isAppointmentUpdated) {
      this.props.clearAll();
      var payload = {
        id: this.state.id,
        startDateTime: this.state.startDateTime,
        endDateTime: this.state.endDateTime,
        status: this.state.status,
        doctorId: this.state.doctorId,
        patientId: this.state.patientId,
        consultationType: this.state.consultationType,
      };
      this.updateHistoryList(payload);
    }
  }

  componentWillUnmount() {
    this.props.clearAll();
  }
  handleFilter = (payload) => {
    this.props.clearAll();
    this.setState({ filterPayload: payload });
    const user = this.props.user;
    var payload = {
      id: payload.id,
      startDateTime:
        payload && payload.startDateTime ? payload.startDateTime : "",
      endDateTime: payload && payload.endDateTime ? payload.endDateTime : "",
      status:
        payload && payload.status
          ? payload.status.map((x) => x.name)
          : this.state.status,
      patientId:
        user.userRole === USER_ROLE.PATIENT
          ? [user.patientId]
          : payload && payload.patientId
          ? payload.patientId.map((x) => x.id)
          : this.state.patientId,
      doctorId:
        user.userRole === USER_ROLE.DOCTOR
          ? [user.doctorId]
          : payload && payload.doctorId
          ? payload.doctorId.map((x) => x.id)
          : this.state.doctorId,
      consultationType:
        payload && payload.consultationType
          ? payload.consultationType.map((x) => x.name)
          : this.state.consultationType,
    };
    this.updateHistoryList(payload);
  };
  handleBookAppointmentButton = () => {
    history.push("/appointments/new");
  };
  handleCancelAppointment = (id) => {
    this.setState({ isCancelRequested: true });
    this.props.cancelAppointment(id);
  };

  handleEditAppointment = (id) => {
    history.push("/appointments/edit/" + id);
  };
  handleConfirmAppointment = (id) => {
    var payload = {
      id: id,
      description: "",
      status: "CONFIRMED",
    };
    this.props.updateAppointment(payload);
  };
  handleUpdateAppointment = () => {};

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Appointments</title>
        </Helmet>
        <Box
          style={{
            backgroundColor: "background.default",
          }}
        >
          <Box display="flex">
            <Box flexGrow={1}>
              <Typography gutterBottom variant="h4" color="primary">
                {this.state.headerTitle}
              </Typography>
            </Box>
            <Box>
              {this.state.showAddNewAppointment &&
              <Button
                variant="button"
                variant="outlined"
                color="primary"
                onClick={() => {
                  this.handleBookAppointmentButton();
                }}
              >
                Book Appointment
              </Button>
  }
            </Box>
            <Box>
              <AppointmentHistoryFilter
                allPatientList={
                  this.props.allPatientList ? this.props.allPatientList : []
                }
                allDoctorList={
                  this.props.allDoctorList ? this.props.allDoctorList : []
                }
                filterPayload={this.state.filterPayload}
                handleFilter={(payload) => {
                  this.handleFilter(payload);
                }}
              />
            </Box>
          </Box>

          {this.props.appointmentList &&
          this.props.appointmentList.length > 0 ? (
            <AppointmentHistoryList
              appointmentList={this.props.appointmentList}
              handleCancelAppointment={(id) => this.handleCancelAppointment(id)}
              handleEditAppointment={(id) => this.handleEditAppointment(id)}
              showSingleGrid={this.state.showSingleGrid ? true : false}
              isCalenderView={this.state.isCalenderView}
              showEditAppointment={this.state.showEditAppointment}
              handleConfirmAppointment={(id) =>
                this.handleConfirmAppointment(id)
              }
              allPatientList={
                this.props.allPatientList ? this.props.allPatientList : []
              }
              allDoctorList={
                this.props.allDoctorList ? this.props.allDoctorList : []
              }
              filterPayload={this.state.filterPayload}
              handleFilter={(payload) => {
                this.handleFilter(payload);
              }}
            />
          ) : (
            <Typography
              gutterBottom
              variant="h4"
              className={classes.typography}
              color="default"
            >
              No appointments found.
            </Typography>
          )}
        </Box>
      </>
    );
  }
}

function mapStateToProps(state) {
  const user = state.authentication.user;
  const appointmentList = state.appointment.appointmentList;
  const isAppointmentUpdated = state.appointment.isAppointmentUpdated;
  const allDoctorList = state.doctor.allDoctorList;
  const allPatientList = state.patient.all;
  return {
    user,
    appointmentList,
    isAppointmentUpdated,
    allDoctorList,
    allPatientList,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllAppointment: (payload) => {
      dispatch(AppointmentActions.getAllAppointment(payload));
    },
    getAllAppointment: (payload) => {
      dispatch(AppointmentActions.getAllAppointment(payload));
    },
    getAllTodayAppointment: (payload) => {
      dispatch(AppointmentActions.getAllTodayAppointment(payload));
    },
    getAllFuturAppointment: (payload) => {
      dispatch(AppointmentActions.getAllFuturAppointment(payload));
    },
    getAllPastAppointment: (payload) => {
      dispatch(AppointmentActions.getAllPastAppointment(payload));
    },
    getAllTomorrowAppointment: (payload) => {
      dispatch(AppointmentActions.getAllTomorrowAppointment(payload));
    },
    getAllWeeklyAppointment: (payload) => {
      dispatch(AppointmentActions.getAllWeeklyAppointment(payload));
    },
    cancelAppointment: (id) => {
      dispatch(AppointmentActions.cancelAppointment(id));
    },
    clearAll: () => {
      dispatch(AppointmentActions.clearAll());
    },
    updateAppointment: (payload) => {
      dispatch(AppointmentActions.updateAppointment(payload));
    },
    getAllDoctor: () => {
      dispatch(DoctorAction.getAllDoctors());
    },
    getAllPatient: () => {
      dispatch(PatientActions.getAllPatients());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(AppointmentHistory));
